import axios from "axios";


export const createStationPhoto = async (station_id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axios.post(`/api/v1/stations/${station_id}/photos`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return res.data;
}

export const deleteStationPhoto = async (station_id, photo_id) => {
    const res = await axios.delete(`/api/v1/stations/${station_id}/photos/${photo_id}`);

    return res.data;
}